// extracted by mini-css-extract-plugin
module.exports = {"container":"MonthHeaderStyles_container__1ODF_"};